<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Specie
      <v-spacer></v-spacer>
      <MdLoader class="mr-2" />
      <v-btn outlined color="green" @click="$refs.nuova_specie.open()"
        ><v-icon class="mr-2">mdi-plus</v-icon> Aggiungi</v-btn
      >
      <NuovaSpecie ref="nuova_specie" />
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <v-text-field
          class="ml-6"
            v-model="filtro"
            label="Filtra specie"
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            :error="filtroNonValido"
            :error-messages="filtroNonValido ? 'Regex non valida' : ''"
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="pl-2 mt-2" align="center">
        <v-col cols="3">
          <span class="text-caption grey--text text-uppercase font-weight-medium">Specie</span>
        </v-col>
        <v-col cols="1">
          <span class="text-caption grey--text text-uppercase font-weight-medium">Esposizione</span>
        </v-col>
        <v-col cols="1">
          <span class="text-caption grey--text text-uppercase font-weight-medium">Manutenzione</span>
        </v-col>
        <v-col cols="1">
          <span class="text-caption grey--text text-uppercase font-weight-medium">Irrigazione</span>
        </v-col>
        <v-col cols="1">
          <span class="text-caption grey--text text-uppercase font-weight-medium">Gelo</span>
        </v-col>
        <v-col cols="1">
          <span class="text-caption grey--text text-uppercase font-weight-medium">Propagazione</span>
        </v-col>
        <v-col cols="1">
          <span class="text-caption grey--text text-uppercase font-weight-medium">Vendita</span>
        </v-col>
        <v-col cols="1" />
        <v-col cols="2">
          <span class="text-caption grey--text">
            {{ specieFiltered.length }}{{ filtro ? ' / ' + species.length : '' }} specie
          </span>
        </v-col>
      </v-row>
      <v-divider class="mb-1" />
      <v-list>
        <SpecieElement
          v-for="specie in specieFiltered"
          :specie="specie"
          :key="specie.id"
        />
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import NuovaSpecie from "./specie_dialog.vue";
import SpecieElement from "./specie_element.vue";
import MdLoader from "./info/md_loader.vue";
export default {
  components: {
    NuovaSpecie,
    SpecieElement,
    MdLoader,
  },
  data() {
    return {
      filtro: "",
    };
  },
  computed: {
    species() {
      return this.$store.getters.get_specie.slice().sort((a, b) =>
        a.nome.localeCompare(b.nome)
      );
    },
    filtroNonValido() {
      if (!this.filtro) return false;
      try {
        new RegExp(this.filtro, "i");
        return false;
      } catch {
        return true;
      }
    },
    specieFiltered() {
      if (!this.filtro || this.filtroNonValido) return this.species;
      const re = new RegExp(this.filtro, "i");
      return this.species.filter((s) => re.test(s.nome) || re.test(s.nome_sc));
    },
  },
  methods: {},
};
</script>